// extracted by mini-css-extract-plugin
export default {"loadMoreContainer":"TableLoadMore__loadMoreContainer---2t","loadMoreBtn":"TableLoadMore__loadMoreBtn--1Tt"};